import { Action, getModule, Module, VuexModule, Mutation } from 'vuex-module-decorators';
import store from '@/store/index';
import { WS_URL as ApiUrl } from '@/config';
import axios from 'axios';
import { NotificationService } from '@/services/notification-service';
import { ExportLicensesActivationCommand, LicenseActivationClient } from '@/apiclient/apiclient_generated';
import LicenseStoreState from '@/types/LicenseStoreState';

@Module({ dynamic: true, namespaced: true, store, name: 'activations' })
export class ActivationModule extends VuexModule {
  private activationsClient = new LicenseActivationClient(ApiUrl, axios);

  allActivations = [];

  // @Action
  // async validateActivation(command: ActivationValidationCommand) {
  //   await this.activationsClient.validateActivation(command)
  // }
  //  @Action
  // async activateLicense(command: ActivationRequestCommand) {
  //   await this.activationsClient.activateLicense(command);
  // }

  @Action
  async getLicenseActivations(licenseId) {
    const activations = await this.activationsClient.getLicenseActivations(licenseId);

    this.setLicenseActivations(activations);
  }

  @Action
  async exportActivations(licenseActivationIds) {
    const command = {
      licenseActivationIds: licenseActivationIds
    } as ExportLicensesActivationCommand;

    return this.activationsClient.export(command).then((data) => data);
  }

  @Action
  async exportClientActivations(licenseActivationIds) {
    const command = {
      licenseActivationIds: licenseActivationIds
    } as ExportLicensesActivationCommand;

    return this.activationsClient.clientExport(command).then((data) => data);
  }

  @Action
  async deleteActivation(activationId) {
    const result = await this.activationsClient.deleteLicenseActivation(activationId);

    if (!result.isSuccess) {
      NotificationService.NotifySuccess(result.errors);
    } else {
      if (result.ids) {
        result.ids.forEach((i) => {
          this.removeActivationFromSource(i);
        });
      }
    }

    return result.isSuccess;
  }

  @Mutation
  setLicenseActivations(activations) {
    activations.forEach((a) => {
      if (a.createTime) {
        a.createTime = new Date(a.createTime);
      }
      if (a.modifiedTime) {
        a.modifiedTime = new Date(a.modifiedTime);
      }
    });

    this.allActivations = activations;
  }

  storeState = {} as LicenseStoreState;

  @Mutation
  updateStoreState(params: LicenseStoreState) {
    this.storeState.selectedAccount = params.selectedAccount;
  }

  @Mutation
  removeActivationFromSource(activationId) {
    const activationIndex = this.allActivations.findIndex((t) => t.autoId === activationId);

    if (activationIndex > -1) {
      this.allActivations.splice(activationIndex, 1);

      NotificationService.NotifySuccess('License Activation was successfully removed.');
    }
  }
}

export const ActivationStore = getModule(ActivationModule);
